"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIQuizBuilderQuestion = exports.isMarkedMatchingOrderAnswer = exports.isMarkedFillTheBlankAnswer = exports.isMarkedDragToOrderAnswer = exports.isMarkedBooleanChoiceAnswer = exports.isMarkedMultipleChoiceAnswer = exports.isMarkedSingleChoiceAnswer = exports.isMarkedTextAnswer = exports.isMatchingOrderAnswer = exports.isFillTheBlankAnswer = exports.isDragToOrderAnswer = exports.isBooleanChoiceAnswer = exports.isMultipleChoiceAnswer = exports.isSingleChoiceAnswer = exports.isTextAnswer = exports.isMatchingOrderQuestion = exports.isFillTheBlankQuestion = exports.isDragToOrderQuestion = exports.isBooleanChoiceQuestion = exports.isMultipleChoiceQuestion = exports.isSingleChoiceQuestion = exports.isTextQuestion = void 0;
var isTextQuestion = function (question) {
    return question.type == "text";
};
exports.isTextQuestion = isTextQuestion;
var isSingleChoiceQuestion = function (question) {
    return question.type == "singleChoice";
};
exports.isSingleChoiceQuestion = isSingleChoiceQuestion;
var isMultipleChoiceQuestion = function (question) {
    return question.type == "multipleChoice";
};
exports.isMultipleChoiceQuestion = isMultipleChoiceQuestion;
var isBooleanChoiceQuestion = function (question) {
    return question.type == "booleanChoice";
};
exports.isBooleanChoiceQuestion = isBooleanChoiceQuestion;
var isDragToOrderQuestion = function (question) {
    return question.type == "dragToOrder";
};
exports.isDragToOrderQuestion = isDragToOrderQuestion;
var isFillTheBlankQuestion = function (question) {
    return question.type == "fillTheBlank";
};
exports.isFillTheBlankQuestion = isFillTheBlankQuestion;
var isMatchingOrderQuestion = function (question) {
    return question.type == "matchingOrder";
};
exports.isMatchingOrderQuestion = isMatchingOrderQuestion;
var isTextAnswer = function (question) {
    return question.questionType == "text";
};
exports.isTextAnswer = isTextAnswer;
var isSingleChoiceAnswer = function (question) {
    return question.questionType == "singleChoice";
};
exports.isSingleChoiceAnswer = isSingleChoiceAnswer;
var isMultipleChoiceAnswer = function (question) {
    return question.questionType == "multipleChoice";
};
exports.isMultipleChoiceAnswer = isMultipleChoiceAnswer;
var isBooleanChoiceAnswer = function (question) {
    return question.questionType == "booleanChoice";
};
exports.isBooleanChoiceAnswer = isBooleanChoiceAnswer;
var isDragToOrderAnswer = function (question) {
    return question.questionType == "dragToOrder";
};
exports.isDragToOrderAnswer = isDragToOrderAnswer;
var isFillTheBlankAnswer = function (question) {
    return question.questionType == "fillTheBlank";
};
exports.isFillTheBlankAnswer = isFillTheBlankAnswer;
var isMatchingOrderAnswer = function (question) {
    return question.questionType == "matchingOrder";
};
exports.isMatchingOrderAnswer = isMatchingOrderAnswer;
var isMarkedTextAnswer = function (question) {
    return question.questionType == "text";
};
exports.isMarkedTextAnswer = isMarkedTextAnswer;
var isMarkedSingleChoiceAnswer = function (question) {
    return question.questionType == "singleChoice";
};
exports.isMarkedSingleChoiceAnswer = isMarkedSingleChoiceAnswer;
var isMarkedMultipleChoiceAnswer = function (question) {
    return question.questionType == "multipleChoice";
};
exports.isMarkedMultipleChoiceAnswer = isMarkedMultipleChoiceAnswer;
var isMarkedBooleanChoiceAnswer = function (question) {
    return question.questionType == "booleanChoice";
};
exports.isMarkedBooleanChoiceAnswer = isMarkedBooleanChoiceAnswer;
var isMarkedDragToOrderAnswer = function (question) {
    return question.questionType == "dragToOrder";
};
exports.isMarkedDragToOrderAnswer = isMarkedDragToOrderAnswer;
var isMarkedFillTheBlankAnswer = function (question) {
    return question.questionType == "fillTheBlank";
};
exports.isMarkedFillTheBlankAnswer = isMarkedFillTheBlankAnswer;
var isMarkedMatchingOrderAnswer = function (question) {
    return question.questionType == "matchingOrder";
};
exports.isMarkedMatchingOrderAnswer = isMarkedMatchingOrderAnswer;
var isIQuizBuilderQuestion = function (e) {
    return !!(e === null || e === void 0 ? void 0 : e.dragId);
};
exports.isIQuizBuilderQuestion = isIQuizBuilderQuestion;
